var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    attrs: {
      "classes": ['customizer-ugc3-overlay', 'ugc-confirm-design']
    }
  }, [_c('div', [_c('div', {
    class: ['ugc-confirm-design-main-image text-center', {
      'tmall': _vm.tmallEnabled
    }]
  }, [_c('base-spinner'), !_vm.isLoading ? _c('img', {
    attrs: {
      "src": _vm.imagesPreview[_vm.compositeImgKey].imgSrc,
      "alt": _vm.pdm.product_name
    }
  }) : _vm._e()], 1), _vm.tmallEnabled ? _c('div', {
    staticClass: "ugc-confirm-design-tmall-message text-center"
  }, [_vm._v("\n      *" + _vm._s(_vm.translations.ugcTmallDesignReadyMessage) + "\n    ")]) : _vm._e(), _c('div', {
    staticClass: "ugc-confirm-design-thumbnail-image"
  }, [!_vm.isLoading ? _c('ul', {
    staticClass: "ugc-confirm-design-thumbnail-image-menu text-center"
  }, _vm._l(_vm.imagesPreview, function (item, key) {
    return _c('li', {
      key: key,
      class: [{
        active: item.active
      }],
      on: {
        "click": function click($event) {
          return _vm.setActive(key);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgSrc,
        "alt": _vm.pdm.product_name
      },
      on: {
        "load": _vm.loading
      }
    })]);
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "ugc-confirm-design-main-text text-center"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.ugcConfirmDesc) + "\n    ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }